class CollectionPaginationNumbers extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', this.onClick.bind(this)); // Bind 'this' context to the onClick method
    });
  }

  onClick(e) {
    e.preventDefault();
    const url = e.target.getAttribute('href'); // Use e.target to get the clicked element
    const productGridContainer = document.getElementById('ProductGridContainer');
    const collection = productGridContainer.querySelector('.collection');
    
    collection.classList.add('loading');

    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const newContent = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

        productGridContainer.innerHTML = newContent;
        const searchParams = url.split('?')[1];
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
        collection.classList.remove('loading');

        // Scroll to the top of the loaded products
        const productsTopOffset = productGridContainer.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: productsTopOffset, behavior: 'smooth' });
      })
      .catch(error => {
        console.error('Error fetching products:', error);
        collection.classList.remove('loading');
      });
  }
}

customElements.define('collection-pagination-numbers', CollectionPaginationNumbers);
